export default __webpack_public_path__ + "static/media/danis.d1167eaa.svg";